import styled from "styled-components";

export const PopupWithMessageContainer = styled.div`
  background: ${({theme}) => theme.white};
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  max-width: 560px;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    min-width: unset;
    width: 100%;
  }
`

export const PopupWithMessageContent = styled.div`
  padding: 42px 52px 24px 52px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  svg{
    margin-bottom: 24px;
  }
  h1{
    font-style: normal;
    font-weight: 700;
    font-size: 19px;
    line-height: 23px;
    text-align: center;
    letter-spacing: 0.4px;
    color:  ${({theme}) => theme.accent};
    margin-bottom: 24px;
  }
  p{
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.3px;
    color: ${({theme}) => theme.grayDark};
    margin-bottom: 24px;
  }
`

export const PopupWithMessageFooter = styled.div`
  border-top: 1px solid ${({theme}) => theme.grayDivider};
  padding: 34px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.2px;
  color: ${({theme}) => theme.accent};
`
